import { type TranslationsKeys } from "./Translations";

const fr: TranslationsKeys = {
  CannotUpgradeToTheSamePlan:
    "Erreur : vous ne pouvez pas vous réabonner pour le même plan.",
  MoreThan1ActiveSubscription: "Erreur : vous avez plus d'un abonnement actif",
  NoBillFoundForCurrentPeriod:
    "Vous devez attendre que votre abonnement démarre pour pouvoir de le changer. Revenez à la date démarrage pour changer votre pack !",
  NoPaymentIntentProvided: "Erreur : pas d'identifiant de payment fourni",
  NoSubscriptions: "Erreur : pas d'abonnements",
  NotASaaSSubscription: "Erreur : pas un abonnement SaaS",
  NotTheSameCommitment:
    "Erreur : impossible de passer d'un engagement annuel à un engagement mensuel",
  PaymentFailed:
    "Échec du traitement du paiement. Veuillez vérifier votre moyen de paiement et réessayer.",
  UnsupportedUseCase: "Erreur : cas non supporté",
  UpsellOk: "UpsellOk",
  UpsellOkWithCompensationBill: "UpsellOkWithCompensationBill",
  a_question: "Une question ?",
  actions: "Actions",
  actionsTableHeader: "Actions",
  actions_performed: "Actions réalisées",
  activate: "Activer",
  active: "Active",
  active_permanently: "Actif en permanence",
  active_players: "Joueurs actifs",
  scheduled: "Programmé",
  scheduled_tooltip:
    "Ce jeu a été ajouté automatiquement selon le calendrier annuel de notre équipe.",
  activity: "Activité",
  addPromoCodeButton: "+ Ajouter un code promo",
  add_button: "Ajouter un jeu",
  add_card: "Ajouter une carte",
  add_ctas_required: "Vous devez ajouter au moins un appel à l'action.",
  add_games_required: "Vous devez ajouter au moins un jeu.",
  add_gifts_required:
    "Vous devez ajouter au moins un cadeau, ou activer les gros lots mensuels.",
  add_new_card: "Ajouter une carte",
  add_to_basket: "Ajouter au panier",
  added_to_basket: "Ajouté ✅",
  all: "Tous les établissements",
  all_accounts: "Tous les établissements",
  ambassador: "Programme d'Ambassadeur",
  analytics_actions_by_sponsoree_title: "Actions réalisées par les filleuls",
  analytics_actions_suffix: "actions",
  analytics_business_ctas: "{{count}} actions business",
  analytics_clients_suffix: "clients",
  analytics_coming_soon: "En construction... 🚧",
  analytics_distribution_in_euros_title: "Répartition en {{currency}}",
  analytics_distribution_share_wom_title: "Répartition par type",
  analytics_email_performance: "Performance des e-mails automatisés",
  analytics_favorite_game_title:
    "🎲 Le jeu préféré de vos clients est... {{game}}",
  analytics_favorite_gift_title:
    "🎂 Le cadeau préféré de vos clients est... {{gift}}",
  analytics_finance: "💶 Finances",
  analytics_game_distribution: "Répartition de parties jouées par jeu",
  analytics_games_suffix: "Parties",
  analytics_marketing: "📣 Marketing",
  analytics_marketing_ctas: "{{count}} actions marketing",
  analytics_new_business: "New Business",
  analytics_no_avg_basket_button: "Renseigner mon panier moyen",
  analytics_no_avg_basket_message:
    "Veuillez renseigner votre panier moyen pour voir vos statistiques",
  analytics_no_avg_basket_message_monthly:
    "Veuillez renseigner votre panier moyen pour voir vos rapports mensuels",
  analytics_no_players_yet: "Vous n'avez pas encore de joueurs",
  analytics_no_redeemed_gift:
    "⚠ Vos clients n'ont récupéré aucun cadeau durant cette période",
  analytics_nothing_to_display: "Pas de données.",
  analytics_participation_plural:
    "{{value}} joueurs ont participé {{label}} fois",
  analytics_participation_singular:
    "{{value}} joueur a participé {{label}} fois",
  analytics_player_sources: "Répartition par source",
  analytics_players: "🙋🏼‍♂️ Joueurs",
  analytics_players_suffix: "pers.",
  analytics_top_3_actions: "Top 3 des actions ⬇️",
  analytics_total_actions_title:
    "👏 {{totalActions}} actions bénéfiques pour votre activité ont été réalisées",
  analytics_total_players_title:
    "🎯 {{totalPlayers}} personnes ont joué {{nGamePlayed}} parties",
  analytics_total_referral_title:
    "📢 Vos clients ont fait découvrir votre établissement à {{totalReturnReferral}} amis",
  analytics_total_repeat_biz_title:
    "💪 Nous avons fait revenir {{totalRepeatBiz}} clients (soit {{totalRepeatBizInCurrency}} de CA )",
  analytics_use_communication_kit:
    "Utilisez votre kit de communication pour diffuser votre animation puis revenez ici pour savourer vos résultats",
  analytics_virality: "Viralité",
  android_bundle_empty_error:
    "L'identifiant du package doit être une chaîne de caractères non vide",
  android_bundle_empty_segment_error: "Le segment {{index}} est vide",
  android_bundle_example: "Exemple : com.exemple",
  android_bundle_invalid_format_error:
    "Format d'identifiant de package invalide",
  android_bundle_invalid_segment_error:
    "Le segment '{{segment}}' est invalide. Il doit commencer par une lettre et ne contenir que des lettres, des chiffres et des underscores",
  android_bundle_min_segments_error:
    "L'identifiant du package doit avoir au moins deux segments",
  android_bundle_reserved_word_error:
    "Le segment '{{segment}}' est un mot réservé Java",
  android_bundle_segment_too_long_error:
    "Le segment '{{segment}}' dépasse la longueur maximale de 255 caractères",
  android_bundle_total_length_error:
    "La longueur totale de l'identifiant dépasse le maximum de 1000 caractères",
  api_error: "Erreur technique (General)",
  api_send_email_error: "Erreur technique",
  api_send_email_success: "Succès\u00A0!",
  api_update_color_error:
    "Une erreur s'est produite, impossible de mettre à jour la couleur",
  apple_store_empty_error:
    "La saisie doit être une chaîne de caractères non vide",
  apple_store_invalid_format_error:
    "Identifiant ou format d'URL AppRouterWrapper Store invalide",
  apply: "Appliquer",
  automated_email: "Emails automatisés",
  automated_emails: "Emails automatisés",
  automated_emails_description:
    "Gardez contact avec vos clients en 100% automatisé et faites-les jouer de chez eux pour qu'ils ne vous oublient jamais.",
  averageBasketLabel: "Panier moyen",
  avgBasket: "Panier moyen",
  bill: "Facture",
  bill_details: "Détails",
  bill_download_th: "Facture",
  bill_exceptional_section_heading:
    "Factures d'achats de supports de communication",
  bill_filename: "facture",
  bill_number_th: "N° de la facture",
  bill_subscription_section_heading: "Factures d'abonnement",
  billing_address_label: "Adresse de facturation",
  billing_country: "Pays de facturation",
  billing_date: "Date de facturation",
  billing_information: "Informations de facturation",
  birthday: "Date de naissance",
  business_profile_active_subscriptions: "Abonnements",
  business_profile_billing_info: "Informations de facturation",
  business_profile_shipping_info: "Informations de livraison",
  business_profile_zone3: "Informations opérationnelles",
  bypass_email_auth: "Désactiver l'authentification par email",
  bypass_email_auth_warning:
    'L\'action "Faire jouer des amis" ne sera pas disponible.',
  cancel: "Annuler",
  cancelSubscriptionButton: "Résilier",
  cancel_button: "Annuler",
  canceled: "Annulé",
  cannot_order_posa_outside_of_france_text:
    "Nous vous invitons à télécharger les modèles qui vous plaisent et à les faire imprimer chez votre imprimeur habituel.",
  cannot_order_posa_outside_of_france_title:
    "Les commandes de supports ne sont pas disponibles dans votre pays 😕",
  card_error_card_expired: "Votre carte bancaire est expirée.",
  card_error_card_inactive:
    "D'après votre banque, cette carte bancaire est inactive. Veuillez contacter votre banque.",
  card_error_debit_limit_exceeded:
    "Vous avez dépassé le plafond de débit de votre carte bancaire. Veuillez contacter votre banque.",
  card_error_debit_transaction_frequency_exceeded:
    "Erreur technique, veuillez nous contacter via la page Contact.",
  card_error_debited_funds_higher_than_pre_authorized_amount:
    "Le montant de la transaction dépasse le montant de la pré-autorisation. Veuillez nous contacter via la page Contact.",
  card_error_invalid_or_missing_bank_details:
    "Informations bancaires manquantes. Veuillez nous contacter via la page Contact.",
  card_error_maximum_amount_exceeded:
    "Vous avez dépassé le montant maximum de paiement de votre carte bancaire. Veuillez contacter votre banque.",
  card_error_maximum_number_of_attempts:
    "Vous avez dépassé le nombre maximum de tentatives de paiement. Veuillez réessayer plus tard.",
  card_error_maximum_uses_exceeded:
    "Vous avez dépassé le nombre maximum de tentatives de paiement. Veuillez réessayer dans 24 heures.",
  card_error_not_active:
    "Problème technique, veuillez nous contacter via la page Contact.",
  card_error_payment_period_expired:
    "Vous avez dépassé le délai imparti pour réaliser le paiement.",
  card_error_payment_refused:
    "Le paiement a été refusé. Veuillez nous contact via la page Contact.",
  card_error_transaction_refused_by_the_bank:
    "Votre banque a refusé cette transaction.",
  card_error_transaction_refused_by_the_bank_card_limit:
    "Vous avez atteint le plafond de votre carte bancaire. Veuillez contacter votre banque.",
  card_expires: "exp.",
  cgv_accept_payment_terms_and:
    "J'accepte les conditions de paiement mentionnées ci-dessus et les",
  cgv_card_debit_text:
    "Votre carte bancaire sera débitée de {{amount}} mensuellement jusqu'à l'échéance de votre abonnement afin de bénéficier du tarif préférentiel de notre formule annuelle.",
  cgv_terms_and_conditions_link_text: "Conditions Générales de Vente",
  change_plan: "Changer de plan >>>",
  checkoutFormValidationError: "Erreur : engagement et/ou plan non spécifié",
  choose_a_model: "Choisir un modèle",
  choose_a_skin: "Choisir un habillage",
  clear: "Effacer",
  clients_per_day_100_to_200: "100 à 200",
  clients_per_day_50_to_100: "50 à 100",
  clients_per_day_less_than_50: "Moins de 50",
  clients_per_day_more_than_200: "Plus de 200",
  clients_per_day_not_relevant:
    "Ce nombre n’est pas pertinent pour mon secteur",
  clients_per_day_unknown: "Je ne connais pas ce nombre",
  close: "Fermer",
  code: "Code",
  code_validation_error_exact_digits:
    "Le code doit contenir exactement 6 chiffres",
  code_validation_error_no_email:
    "Pas d'email. Redirection vers la page d'inscription",
  code_validation_error_required: "Le code est obligatoire",
  code_validation_footer_different_address: "avec une adresse différente.",
  code_validation_footer_or: "ou",
  code_validation_footer_resend_email: "Renvoyez l'e-mail",
  code_validation_footer_restart: "recommencez",
  code_validation_footer_something_wrong: "Ça ne marche pas ?",
  code_validation_heading: "Un code de vérification a été envoyé à votre email",
  code_validation_subheading: "Entrez le code à 6 chiffres envoyé à {{email}}",
  colorFormatError: "Format de couleur invalide.",
  colorInputPlaceholder: "#hex,rgb(r,g,b), cmyk(c%,m%,y%,k%)",
  color_background: "Couleur de fond",
  color_buttons: "Couleur des boutons",
  color_secondary: "Couleur secondaire",
  color_subtitle: "Couleur des sous-titres",
  color_test_primary: "Couleur primaire",
  color_test_secondary: "Couleur secondaire",
  color_test_title: "Test des couleurs",
  color_titles: "Couleur des titres",
  comment_placeholder: "Ajouter votre commentaire",
  comments: "Commentaires",
  commitment_end_label: "Renouvellement",
  commitment_label: "Engagement",
  configure: "Configurer",
  confirm: "Confirmer",
  confirm_delete_card: "Êtes-vous sûr de vouloir supprimer cette carte ?",
  confirm_deletion: "Confirmez-vous la suppression ?",
  confirm_plv_order: "Confirmez votre commande de PLV",
  confirm_plv_order_back_button: "Retour",
  confirm_plv_order_place_order_button: "Passer la commande",
  confirm_subscription: "Confirmer l'abonnement",
  contact: "Contact",
  continue: "Continuer",
  copy_link: "Copier le lien",
  country_placeholder: "Pays",
  coupon_immediate_placeholder: "Coupon cadeau récupérable immédiatement",
  coupon_next_day_placeholder:
    "Coupon cadeau récupérable dès le lendemain du gain",
  coupon_redemption_method: "Méthode de récupération des coupons",
  coupon_redemption_qr_code: "QR code",
  coupon_redemption_soft_redeem: "Auto-destruction",
  coupon_redemption_validation_code: "Code de validation",
  create_custom_design: "Choisissez un modèle",
  create_first_animation: "Créez votre première animation",
  create_my_free_game: "Créer mon jeu gratuit\u00A0!",
  create_my_game: "Créer mon jeu\u00A0!",
  create_new_animation: "Créer une nouvelle animation",
  cta_buy_and_photo: "Acheter et prendre mon addition en photo",
  cta_card_change_image: "Changer l'image",
  cta_card_checkin_code_placeholder: "Code de check-in",
  cta_card_keyword_1: "Mot-clé 1",
  cta_card_keyword_2: "Mot-clé 2",
  cta_card_keyword_3: "Mot-clé 3",
  cta_card_ocr_detected_amount: "Montant détecté",
  cta_card_ocr_detected_datetime: "Date et heure détectées",
  cta_card_ocr_found: "✓ Trouvé dans le reçu",
  cta_card_ocr_not_found: "✗ Non trouvé dans le reçu",
  cta_card_receipt_keywords_instruction:
    "Entrez jusqu'à 3 mots-clés qui identifient de manière unique vos additions.",
  cta_card_test_receipt_ocr: "Tester un reçu ou une addition",
  cta_card_tooltip_bao:
    "L'objectif de cet appel à l'action est de distribuer un maximum de coupons cadeau auprès des amis de vos clients qui, a priori sont votre meilleure cible. Vos clients auront alors le plaisir d'offrir un cadeau à leurs amis en leur faisant parvenir un lien via le canal de leur choix (Whatsapp, SMS, etc.).",
  cta_card_tooltip_checkin:
    "C'est comme tamponner une carte de fidélité, sauf que le client devra faire scanner son code QR par votre personnel pour valider sa visite. La validation peut être effectuée avec n'importe quel smartphone à l'aide d'un code à 4 chiffres que seul votre personnel connaîtra.",
  cta_card_tooltip_receipt:
    "Avec cet appel à l'action, vos clients doivent prouver qu'ils ont réalisés un achat en photographiant leur addition. Nous détecterons automatiquement que la photo a bien été prise dans votre établissement grâce à vos informations spécifiques (SIREN, SIRET, numéro de TVA, téléphone).",
  cta_card_tooltip_share:
    "Cet appel au partage va permettre de vous faire connaître en faisant jouer les amis de vos clients. Vos clients partageront votre salle de jeux en utilisant le canal de leur choix (Whatsapp, SMS, etc.). Il s'agira des mêmes jeux, avec les mêmes chances de gain mais avec des appels à l'action adaptés à un parcours de découverte : Participation #1 : Découvrir vos réseaux sociaux Participation #2 : Voir l'emplacement sur Google Maps Participation #3 : Remplir un mini-formulaire (pour une meilleure connaissance de vos prospects) Participation #4 : Réaliser un achat (photo d'addition): maintenant qu'il vous connaît et qu'il a joué plusieurs fois, il est temps de passer à la caisse!",
  cta_card_tooltip_whatsappgroup:
    "Créez un groupe WhatsApp et collez le lien ici pour encourager vos clients à le rejoindre. Voici comment trouver le lien :",
  cta_card_tooltip_whatsappgroup_1: "1. Rendez-vous dans votre groupe Whatsapp",
  cta_card_tooltip_whatsappgroup_2: "2. Cliquez sur le nom du groupe",
  cta_card_tooltip_whatsappgroup_3:
    "3. Cliquez sur \u00AB Ajouter des personnes \u00BB puis sur \u00AB Inviter dans la communauté via un lien \u00BB",
  cta_card_tooltip_whatsappgroup_4: "4. Collez le lien ici",
  cta_card_upload_receipt_image: "Cliquez pour télécharger une image de reçu",
  cta_card_whatsapp_group_link_placeholder:
    "Lien du groupe WhatsApp (ex: https://chat.whatsapp.com/...)",
  cta_checkin: "Tamponner ma visite",
  cta_custom_button_text_placeholder: "Texte personnalisé (facultatif)",
  cta_custom_form: "Formulaire personnalisé",
  cta_custom_form_contact_team:
    "Contactez notre équipe pour modifier cette action",
  cta_customer_of_month_reward: "Récompense du client du mois",
  cta_disabled_bea:
    "Vous avez désactivé l'authentification par email, vous ne pouvez pas activer cette action",
  cta_discover_website: "Visiter un lien",
  cta_download_app: "Télécharger l'application",
  cta_editor_heading_2: "Actions one-shot",
  cta_editor_heading_3: "Actions répétables",
  cta_editor_paragraph_2:
    "Incitez vos clients à réaliser des actions qui boosteront votre référencement, vos réseaux sociaux etc.",
  cta_facebook_like: "Aimer la page Facebook",
  cta_follow_snapchat: "S'abonner à Snapchat",
  cta_follow_tiktok: "S'abonner à TikTok",
  cta_give_birth_date: "Donner ma date de naissance",
  cta_give_feedback_title: "Donner mon feedback",
  cta_instagram_check_out: "Suivre sur Instagram",
  cta_instagram_story: "Faire une story Instagram",
  cta_leave_first_name: "Laisser mon prénom",
  cta_leave_phone: "Laisser mon numéro de téléphone",
  cta_leave_postal_code: "Laisser mon code postal",
  cta_leave_review: "Laisser un avis",
  cta_lets_meet: "Faisons connaissance\u00A0!",
  cta_link_fields_placeholder: "https://votresite.fr",
  cta_link_fields_placeholder_android_playstore:
    "Lien Play Store Android (ex. https://play.google.com/store/apps/details?id=com.example.app)",
  cta_link_fields_placeholder_ios_appstore:
    "Lien AppRouterWrapper Store iOS (ex. https://apps.apple.com/app/id123456789)",
  cta_link_fields_placeholder_tripadvisor:
    'Lien de votre page "Rédiger un avis" sur TripAdvisor',
  cta_loyalty_reward: "Récompense de fidélité",
  cta_newsletter_subscribe: "S'abonner à la newsletter",
  cta_photo: "Photo",
  cta_place_online_order: "Passer une commande en ligne",
  cta_play_with_friends: "Faire jouer des amis",
  cta_rate_1_to_10: "Noter de 1 à 10",
  cta_rate_deliveroo: "Noter sur Deliveroo",
  cta_rate_ubereats: "Noter sur UberEats",
  cta_rate_ubereats_or_deliveroo: "Noter sur UberEats ou Deliveroo",
  cta_send_gift_card: "Envoyer une carte cadeau à un ami",
  cta_simulate_performance: "Simulez les performances de votre jeu",
  cta_sponsor_friend: "Parrainer un ami",
  cta_tripadvisor_review: "Laisser un avis sur TripAdvisor",
  cta_visualize_location: "Visualiser l'emplacement",
  cta_whatsapp_group: "Rejoindre le groupe Whatsapp",
  cta_whatsapp_hello: "Faites nous un coucou sur Whatsapp\u00A0!",
  currency: "Devise",
  custom: "Personnalisé",
  custom_quote: "Sur devis",
  custom_str: "Sur devis",
  customerUpdateError: "Impossible de mettre à jour le client",
  dashboard: "Statistiques",
  dashboard_detail: "Dashboard",
  data: "Données",
  data_protection_agreement: "Accord de protection des données",
  date: "Date",
  date_and_hour: "Date et heure",
  date_format_abbreviated: "DD MMM YYYY",
  date_format_between: "le {{startDate}} et le {{endDate}}",
  date_format_datepicker: "dd/MM/yyyy",
  date_format_full_date: "DD/MM/YYYY",
  date_format_full_with_time: "DD/MM/YYYY HH:mm",
  date_format_month_only: "MMMM",
  date_format_month_year: "MMMM YYYY",
  debug_text_debug: "Debug",
  default_redeem_condition: "Sous réserve de consommation",
  delete_account: "Supprimer compte",
  delete_card: "Supprimer la carte",
  deliverer_will_call: "Les livreurs appelleront ce numéro en cas de problème",
  deliveryContactLabel: "Contact de livraison",
  deliveryContactPhoneLabel: "Numéro de téléphone du contact de livraison",
  deliveryInfoPlaceholder: "Informations de livraison",
  describe_your_need: "Décrivez votre besoin",
  description_required: "La description est requise",
  discover_highlights_ideas:
    "💡Découvrez des idées d'animations pour vos temps forts",
  display_currency: "Devise du panier moyen",
  display_date_format: "DD/MM/YYYY",
  display_dates: "Afficher ces dates",
  distribution: "Répartition",
  do_not_validate: "Ne pas valider",
  downgrade_blocked_message:
    "Un commercial vous contactera sous peu afin de trouver une solution adaptée à vos besoins.",
  downgrade_blocked_title: "Cette action n'est pas autorisée ⚠️",
  downgrade_contact_confirmed_message:
    "Vos coordonnées ont bien été prises en compte",
  downgrade_contact_confirmed_title: "C'est noté !",
  downgrade_request_acknowledged_message:
    "Nous avons déjà vos coordonnées, un membre de notre équipe vous contactera sous peu",
  download: "Télécharger",
  download_logo: "Télécharger votre logo",
  download_posa_text:
    "Dans quel format souhaitez vous télécharger votre bon à tirer ?",
  download_your_materials: "Télécharger vos supports",
  dpaURL:
    "https://s3.eu-west-3.amazonaws.com/cadeaudelamaison.com/kadow/pdf/SAS_Toot_Sweet_Kadow_Club_Accord_de_protection_des_donnees_APD.pdf",
  dpa_text_1: "J'accepte l'",
  dpa_text_2: "Accord de Protection des Données (APD)",
  draft: "Brouillon",
  drive_to_store_legend: "Drive to store",
  edit_place_name: "Modifier le nom",
  edit_your_posa: "Modifiez votre support de com'",
  email: "Email",
  emailLabel: "Email",
  email_content: "Contenu de l'email",
  email_invalid_format: "Format d'email invalide",
  email_required: "L'email est requis",
  emails_and_numbers: "Opt-in",
  emoji_category_activities: "Activités",
  emoji_category_animals_nature: "Animaux et nature",
  emoji_category_flags: "Drapeaux",
  emoji_category_food_drink: "Nourriture et boissons",
  emoji_category_objects: "Objets",
  emoji_category_recent: "Récents",
  emoji_category_smileys: "Smileys",
  end_date: "Fin",
  enter_internal_name: "Nom interne (ex : numéro de point de vente)",
  enter_public_name: "Nom affiché à vos clients",
  enterprise: "Enterprise",
  err_NoSuchPlan: "Ce plan n'existe pas",
  err_Unauthorized: "Accès non autorisé",
  error: "Erreur",
  errorAlert: "Erreur",
  errorTitle: "Erreur",
  error_account_not_exist: "Ce compte n'existe pas",
  error_connection_impossible: "Connexion impossible",
  error_connection_link_expired: "Le lien de connexion a expiré",
  error_connection_link_malformed:
    "Le lien de connexion est erroné ou malformé",
  error_creating_venue:
    "Échec de la création du nouveau lieu. Veuillez réessayer.",
  error_failed_fetch_neutre_event:
    "Échec de récupération de l'événement neutre :",
  error_general_message: "Erreur",
  error_generic: "Une erreur s'est produite. Veuillez réessayer.",
  error_legacy_backend_failed:
    "Échec de la création de la commande. Veuillez contacter le support.",
  error_no_svg_element: "Aucun élément SVG trouvé",
  error_occurred_please_retry: "Une erreur est survenue. Veuillez réessayer.",
  error_pdf_generation_failed:
    "Échec de la génération du fichier PDF. Veuillez réessayer.",
  error_promo_code_already_used: "Ce code promo a déjà été utilisé.",
  error_promo_code_expired: "Ce code promo est expiré",
  error_promo_code_malformed: "Ce code promo est invalide ou mal formé",
  error_promo_code_not_authorized:
    "Cette licence gratuite n'est pas autorisée pour votre compte. Veuillez contacter votre commercial.",
  error_promo_code_not_exist: "Ce code promo n'existe pas",
  error_promo_code_plan_mismatch:
    "Ce code promo n'est pas valable pour ce plan. Veuillez sélectionner le bon plan ou utiliser un autre code promo.",
  error_quote_already_used: "Ce devis a déjà été utilisé.",
  error_quote_no_longer_valid: "Ce devis n'est plus valide.",
  error_s3_upload_failed:
    "Échec de l'envoi du fichier sur le serveur. Veuillez réessayer.",
  error_updating_place_name:
    "Erreur lors de la mise à jour du nom de l'établissement",
  error_validation_failed:
    "Échec de la validation de la commande. Veuillez contacter le support.",
  error_verification_code_incorrect: "Le code de vérification est incorrect",
  error_with_code: "{{message}} ({{code}})",
  establishment: "Établissement",
  establishmentTableHeader: "Etablissement",
  event_display_from: "Diffusion du",
  event_display_to: "au",
  expired: "Expiré",
  expiry_delay_12_hours: "12 heures",
  expiry_delay_12_months: "12 mois",
  expiry_delay_1_day: "1 journée",
  expiry_delay_1_month: "1 mois",
  expiry_delay_1_week: "1 semaine",
  expiry_delay_2_months: "2 mois",
  expiry_delay_2_weeks: "2 semaines",
  expiry_delay_3_months: "3 mois",
  expiry_delay_3_weeks: "3 semaines",
  expiry_delay_6_months: "6 mois",
  expiry_delay_disabled: "Désactivé",
  explanatory_video: "Voir la video explicative",
  facebookIdHelpText:
    "Où trouver l'identifiant numérique de ma page Facebook ?",
  facebookIdInstructions:
    "Pour trouver l'identifiant numérique de votre page Facebook, veuillez suivre les étapes suivantes :",
  facebookIdModalTitle:
    "Où trouver l'identifiant numérique de ma page Facebook ?",
  facebookIdStep1: "Rendez-vous sur votre page",
  facebookIdStep2: 'Allez dans "A propos"',
  facebookIdStep3:
    "En bas de la page, vous verrez votre identifiant numérique affiché",
  facebookPageIdStatus: "Identifiant de la page Facebook",
  feedback: "Feedback",
  feedbacks: "Feedbacks",
  field_required: "Obligatoire",
  finish: "Terminer",
  first_payment_will_take_place:
    "Le 1er paiement aura lieu à la date de démarrage indiquée",
  follow_up_scenario: "Scénario de relance",
  form_button_add: "Ajouter",
  form_button_modify: "Modifier",
  form_button_save: "Sauvegarder",
  form_data: "Données des formulaires",
  free: "Gratuit",
  free_license_confirm_button: "Obtenir ma licence gratuite",
  free_license_description:
    "Vous êtes sur le point d'activer une licence {{planName}} gratuite.",
  free_license_title: "Licence gratuite",
  free_trial_confirm_button: "Demander à être rappelé",
  free_trial_confirm_message:
    "Notre équipe commerciale prendra contact avec vous pour vérifier votre éligibilité et vous accompagner dans la mise en place de votre test gratuit.",
  free_trial_confirm_phone_prompt:
    "Veuillez confirmer ou corriger le numéro de téléphone auquel vous souhaitez être rappelé :",
  free_trial_confirm_title: "Demander un test gratuit",
  free_trial_request_sent: "Demande de test gratuit envoyée ☑️",
  free_trial_success_message: "Vous recevrez un appel dans les prochaines 48h",
  free_trial_success_title: "Votre demande a bien été prise en compte",
  from: "Du",
  full_address: "Adresse complète",
  full_screen_desc:
    "Chaque fois qu'un joueur scannera le QR code, un jeu s'affichera en plein écran.",
  full_screen_mode: "Mode plein-écran",
  game: "Jeu",
  game_country: "Pays où se déroulera le jeu",
  game_end_date: "Date de fin du jeu",
  game_select: "Sélectionner",
  game_selected: "Sélectionné ✅",
  game_start_date: "Date de début du jeu",
  game_type_3d_dice: "Dés magiques",
  game_type_balloon_blast: "Éclate-ballons",
  game_type_breakout: "Casse-briques",
  game_type_catcher: "Catcher",
  game_type_fakir_game: "Jeu du Fakir",
  game_type_flip_cards: "Cartes à retourner",
  game_type_jumper: "Jumper",
  game_type_kadow_crush: "Cadeau Crush",
  game_type_monthly_lottery: "Jeu de perf",
  game_type_mystery_boxes: "Boîtes mystères",
  game_type_penalty_kick: "Tirs au but",
  game_type_prognosis: "Pronostics",
  game_type_puzzle: "Puzzle",
  game_type_quiz: "Quizz / blind tests",
  game_type_scratch_card: "Carte à gratter",
  game_type_slot_machine: "Machine à sous",
  game_type_space_invaders: "Space Invaders",
  game_type_wheel_of_fortune: "Roue de la fortune",
  game_type_wordle: "Wordle",
  games_and_skins: "Jeux",
  games_played: "Parties jouées",
  games_redeemed: "Cadeaux récupérés",
  games_won: "Parties gagnées",
  generate_gift_ideas: "Générer des idées de cadeaux",
  generated_revenue: "Boost en {{currency}}",
  generic_error: "Une erreur s'est produite",
  gift: "Cadeau",
  gift_expiry_delay_label: "Délai d'expiration du cadeau",
  gift_expiry_reminder_text:
    "Nous relancerons vos clients à l'approche de l'expiration du cadeau",
  gift_name_min_characters: "Le nom doit contenir au moins 5 caractères",
  gift_name_must_start_with_number:
    'Le nom doit commencer par un nombre, ou un nombre en toutes lettres (ex: "1 café" ou "Trois boissons")',
  gift_name_required: "Le nom est requis",
  gift_percentage_placeholder: "% de gagnants sur ce cadeau",
  gift_percentage_sum_exceed:
    "La somme des pourcentages ne doit pas dépasser 100% (total actuel : {{sum}}%)",
  gift_selector_chance_exceed:
    "Les chances de gain ne peuvent pas dépasser 100%.",
  gift_selector_specify_chance:
    "Veuillez préciser une chance de gain pour chaque cadeau.",
  gift_suggestions_description:
    "Voici quelques idées de cadeaux en lien avec votre secteur",
  gift_with_name_and_percentage: "{{name}} : {{pc}}%",
  gift_with_position: "Cadeau {{position}}",
  gift_with_position_and_percentage: "Cadeau {{position}} : {{pc}}%",
  go_to_ctas_page: "Ajouter des appels à l'action",
  go_to_games_page: "Ajouter des jeux",
  go_to_prizes_page: "Ajouter des cadeaux",
  googlePlaceStatus: "Votre établissement sur Google",
  highlight_date: "Du {{startDate}} au {{endDate}}",
  highlight_name: "Temps fort",
  iframe_not_supported: "Les iframes ne sont pas supportées.",
  impossible_action: "Cette action est impossible",
  incomplete: "Incomplète",
  incomplete_game:
    "Veuillez finaliser votre configuration pour tester votre jeu",
  incomplete_game_cta_missing: "Appel à l'action : ❌",
  incomplete_game_cta_present: "Appel à l'action : ✅",
  incomplete_game_game_missing: "Jeu : ❌",
  incomplete_game_game_present: "Jeu : ✅",
  incomplete_game_intro:
    "Un minimum d'un jeu, un lot et un appel à l'action configurés sont nécessaires pour faire fonctionner votre jeu. Voici votre statut actuel :",
  incomplete_game_prize_missing: "Lot : ❌",
  incomplete_game_prize_present: "Lot : ✅",
  incomplete_game_test_warning_link:
    "⚠️ Vous pouvez toujours tester le jeu, mais il pourrait être instable. Vous pouvez utiliser le lien ci-dessous ⚠️",
  incomplete_game_test_warning_qr:
    "⚠️ Vous pouvez toujours tester le jeu, mais il pourrait être instable. Vous pouvez utiliser le QR code ci-dessous ⚠️",
  info_delivering_billing_address: "Adresse de facturation *",
  info_delivering_billing_country: "Pays de facturation",
  info_delivering_billing_country_placeholder: "Pays de facturation",
  info_delivering_billing_info: "Informations de facturation",
  info_delivering_company_name_placeholder: "Pastèque SARL, Ananas SAS, etc",
  info_delivering_company_optional: "Société (facultatif)",
  info_delivering_delivery_contact: "Contact pour la livraison *",
  info_delivering_next: "Suivant",
  info_delivering_phone_number: "Numéro de téléphone à contacter *",
  info_delivering_previous: "Précédent",
  info_delivering_shipping_info: "Informations de livraison",
  info_delivering_shipping_name_placeholder: "Ex. John Smith",
  info_delivering_shipping_phone_placeholder: "Ex. 06 01 01 01 01",
  instagramLinkPlaceholder: "Lien de votre page Instagram",
  instagramProfileStatus: "Profil Instagram",
  internal_name: "Nom interne",
  invoices: "Factures",
  jetpackConfigUpdateError:
    "Impossible de mettre à jour la configuration jetpack",
  jetpack_checkout_form_become_member: "Devenir membre",
  jetpack_checkout_form_billing_country_placeholder: "Pays de facturation",
  jetpack_checkout_form_club: "club",
  jetpack_checkout_form_company_optional: "Société (facultatif)",
  jetpack_checkout_form_error_no_promo_code: "Pas de code promo",
  jetpack_checkout_form_error_price_calculation: "Erreur de calcul des prix",
  jetpack_checkout_form_payment_method: "Moyen de paiement",
  jetpack_checkout_form_promo_code: "Code promo",
  jetpack_checkout_form_success_body:
    "Nous confirmons que votre licence {{planName}} a été activée.",
  jetpack_checkout_form_success_button: "Explorer votre pack {{planName}}",
  jetpack_checkout_form_success_header: "C'est parti ! 🚀",
  jetpack_config_checkin_code_required:
    "Le code de check-in doit être composé de 4 chiffres.",
  jetpack_config_cta_gain_min_error: "Un CTA doit rapporter au moins 1 jeton",
  jetpack_config_cta_link_required: "Le lien est obligatoire.",
  jetpack_config_cta_link_validation_error:
    "Veuillez corriger votre lien URL car il ne mène nulle part.",
  jetpack_config_cta_test_error: "Le lien doit être défini.",
  jetpack_config_download_pdf: "PDF",
  jetpack_config_download_png: "PNG",
  jetpack_config_google_address_required:
    "Veuillez renseigner une adresse afin de trouver votre établissement sur Google.",
  jetpack_config_ocr_keywords_required:
    "Vous devez fournir au moins un mot-clé.",
  jetpack_config_whatsapp_group_link_invalid:
    "Le lien du groupe WhatsApp doit être au format https://chat.whatsapp.com/XXXXXX",
  jetpack_config_whatsapp_group_link_required:
    "Le lien du groupe WhatsApp est obligatoire.",
  jetpack_onboarding_step_1_title: "Finalisez votre inscription",
  jetpack_onboarding_step_2_description:
    "Vos jeux apparaîtront dans votre salle de jeu. Ils pourront être modifiés à tout moment.",
  jetpack_onboarding_step_2_title: "Choisissez un ou plusieurs jeux\u00A0!",
  jetpack_onboarding_step_8_description:
    "Vous pourrez modifier les intitulés, les emojis ainsi que les chances de gain à tout moment.",
  jp_add_gift_btn_text: "Ajouter un cadeau",
  jp_default_place_name: "Établissement",
  jp_finalize_button_text: "Finaliser mon jeu",
  jp_next_btn_text: "Étape suivante",
  jp_onboarding_description_step_cta:
    "Saisissez le nom de votre établissement afin de configurer votre page Google et obtenir des avis\u00A0!",
  jp_onboarding_form_label_avg_basket: "Panier moyen",
  jp_onboarding_form_label_clients_per_day:
    "Combien de clients par jour avez-vous ? (Tous points de vente et canaux confondus : sur place, livraison, etc.)",
  jp_onboarding_form_label_email: "Email de contact",
  jp_onboarding_form_label_first_name: "Prénom",
  jp_onboarding_form_label_last_name: "Nom",
  jp_onboarding_form_label_operational_contact: "Responsable de mise en place",
  jp_onboarding_form_label_operational_contact_phone: "Téléphone",
  jp_onboarding_form_label_place_name: "Nom du lieu",
  jp_onboarding_form_label_sector: "Secteur",
  jp_onboarding_game_preview_text_1:
    "Accédez à votre tableau de bord pour revoir les détails de votre animation et choisir vos supports de communication !",
  jp_onboarding_game_ready_text: "Votre jeu est presque prêt",
  jp_onboarding_giftform_generate_ideas: "Générer des idées",
  jp_onboarding_giftform_helper_format:
    "Pour une lisibilité optimale, nous recommandons le format suivant : '1 dessert', '1 cocktail', '1 boisson'",
  jp_onboarding_giftform_label_percentage: "Pourcentage de gain",
  jp_onboarding_giftform_placeholder_name: "1 dessert",
  jp_onboarding_placeholder_google_place_id:
    "Nom et adresse de l'établissement",
  jp_onboarding_socials_placeholder_facebook:
    "Lien vers la page Facebook de votre établissement",
  jp_onboarding_socials_placeholder_instagram:
    "Lien vers la page Instagram de votre établissement",
  jp_onboarding_socials_placeholder_snapchat:
    "Compte Snapchat de votre établissement",
  jp_onboarding_socials_placeholder_tiktok:
    "Compte TikTok de votre établissement",
  jp_onboarding_step_gift_gift_name: "Nom du cadeau",
  jp_onboarding_step_gift_gifts_text: "Cadeau",
  jp_onboarding_step_gift_label_condition: "Conditions de récuperation",
  jp_onboarding_step_gift_placeholder_condition_01:
    "Condition de récupération 1",
  jp_onboarding_step_gift_placeholder_condition_02:
    "Condition de récupération 2 (facultative)",
  jp_onboarding_step_gift_placeholder_condition_03:
    "Condition de récupération 3 (facultative)",
  jp_onboarding_step_gift_toggle_label_condition:
    "Cadeau récupérable sous conditions",
  jp_onboarding_subtitle_step_cta: "Identifiant Google",
  jp_onboarding_title_step_cta_selector: "Votre appel à l'action\u00A0!",
  jp_onboarding_title_step_gift_selector: "Préselectionnez 3 à 5 cadeaux",
  jp_onboarding_title_step_gift_selector_01: "Voici quelques idées de cadeaux",
  jp_prize_sector_bar_00: "1 portion de frites",
  jp_prize_sector_bar_01: "1 planche apéro",
  jp_prize_sector_bar_02: "1 cocktail",
  jp_prize_sector_cafe_00: "1 café",
  jp_prize_sector_hotel_00: "1 petit déjeuner",
  jp_prize_sector_hotel_01: "1 coupe de champagne",
  jp_prize_sector_hotel_02: "-X% sur votre prochain séjour",
  jp_prize_sector_park_00: "-20% sur votre prochaine entrée",
  jp_prize_sector_park_01: "1 boisson",
  jp_prize_sector_park_02: "-20% de réduction sur X",
  jp_prize_sector_restaurant_00: "1 dessert",
  jp_prize_sector_restaurant_01: "1 boisson",
  jp_prize_sector_restaurant_02: "1 menu",
  jp_prize_sector_shop_00: "1 bon de reduction de -20%",
  jp_prize_sector_shop_01: "1 tote bag",
  jp_prize_sector_shop_02: "1 accessoire",
  jp_prize_wellness_00: "1 soin",
  jp_prize_wellness_01: "1 produit",
  jp_prize_wellness_02: "20% de réduction",
  jp_proceed: "À finaliser",
  jp_return_btn_text: "Retour",
  jp_sector_bar: "Bar",
  jp_sector_cafe: "Café",
  jp_sector_hotel: "Hôtel",
  jp_sector_park: "Loisirs",
  jp_sector_restaurant: "Restaurant",
  jp_sector_shop: "Boutique",
  jp_skip_btn_text: "Passer cette étape →",
  jp_validate_gift_text: "Valider mes cadeaux",
  jp_weekly_quantity_limit_label: "Avec une limite de quantité hebdomadaire",
  jp_win_change_desc_00: "Les joueurs auront ",
  jp_win_change_desc_01: " de chances de gagner un cadeau et ",
  jp_win_change_desc_02: " de chances de perdre",
  jp_win_change_text: "Probabilités de gagner vos cadeaux",
  kc_input_label: "Label input",
  kc_input_placeholder: "Votre text ici...",
  last: "Dernier",
  legal: "Juridique",
  light: "Light",
  linkPlaceholder: "Lien",
  list: "Détaillée",
  loading: "Chargement...",
  log_in: "Se connecter",
  login_hero_text: "Offrir un kadow va vous rapporter grow",
  logo_size: "Taille du logo",
  logo_upload_instructions: "PNG, JPEG ou WEBP",
  logout: "Se déconnecter",
  loss_percentage: "Chances de perdre : {{percentage}}%",
  loyalty: "Programme de Fidélité",
  loyalty_choose_my_gifts: "Choisir mes cadeaux",
  loyalty_customer_of_month_section_title: "Cadeau du client du mois",
  loyalty_customize_reward: "Personnaliser la récompense",
  loyalty_delete_prize_offer_tokens:
    "Supprimer ce cadeau et offrir des jetons de jeu",
  loyalty_disable_confirmation:
    "Ceci aura pour effet de désactiver votre programme de fidélité. Confirmer la suppression ?",
  loyalty_gifts_configure_leaderboard: "Configurer le client du mois",
  loyalty_gifts_configure_tiers: "Configurer les récompenses des paliers",
  loyalty_gifts_configure_tiers_desc:
    "Définir un cadeau ou des jetons pour chaque palier de fidélité.",
  loyalty_gifts_heading: "Choisissez vos cadeaux",
  loyalty_leaderboard_disable_confirmation:
    "Votre client du mois n'aura aucune récompense. Confirmer la suppression ?",
  loyalty_leaderboard_special_prize_desc:
    "Ces cadeaux sont attribués automatiquement chaque mois aux clients ayant réalisé le plus d'actions.",
  loyalty_leaderboard_special_prize_label: "Gros lot spécial du classement",
  loyalty_leaderboard_tie_warning:
    "En cas d'égalité, ce cadeau peut être attribué à plusieurs clients.",
  loyalty_leaderboard_top_customer_reward_desc:
    "Récompense pour le ou les clients ayant réalisé le plus grand nombre d’actions chaque mois",
  loyalty_prizes_section_description:
    "Ces cadeaux sont attribués automatiquement aux clients qui débloquent des badges en fonction du nombre d'actions réalisées.",
  loyalty_prizes_section_title: "Cadeaux de fidélité",
  loyalty_threshold_actions: "{{count}} action",
  loyalty_threshold_actions_plural: "{{count}} actions",
  loyalty_tokens_count: "{{count}} jetons",
  ma_birthday: "Anniversaire",
  ma_birthday_desc: "Jeton offert le jour de l'anniversaire du joueur",
  ma_loyalty_customer_of_the_month_desc:
    "Email envoyé le 1er du mois à tous les premiers du classement du client du mois.",
  ma_loyalty_customer_of_the_month_title: "Client du mois",
  ma_reminder: "Rappel de gain",
  ma_reminder_desc:
    "Trois emails envoyés avant l'expiration, rappelant à une personne qu'elle a gagné un cadeau.",
  ma_tokens_offered: "Jetons offerts",
  ma_tokens_offered_desc: "Le 15 de chaque mois",
  ma_welcome_email: "Email de bienvenue",
  ma_welcome_email_desc: "J+3 après l'inscription",
  mandatory: "Obligatoire",
  marketing_automation_lottery_loss_description:
    "Le jour du tirage au sort d'un gros lot. Vous ne pouvez pas désactiver ce scenario.",
  marketing_automation_lottery_loss_title: "Défaite au tirage au sort",
  marketing_automation_lottery_win_description:
    "Le jour du tirage au sort d'un gros lot. Vous ne pouvez pas désactiver ce scenario.",
  marketing_automation_lottery_win_title: "Victoire au tirage au sort",
  marketing_automation_scenario_cannot_be_disabled_message:
    "Ce scénario ne peut pas être désactivé",

  marketing_automation_scenario_cannot_be_disabled_title:
    "Impossible de désactiver le scénario",
  marketing_automation_win_email_description:
    "Lorsqu'un joueur gagne un cadeau. Vous ne pouvez pas désactiver ce scenario.",
  marketing_automation_win_email_title: "Email de gain",
  max_characters: "Doit contenir au plus {{n}} caractères",

  means_of_payment: "Moyens de paiement",
  min_characters: "Doit contenir au moins {{n}} caractères",
  ml_configure_title: "Configurez vos gros lots",
  ml_monthly_prizes: "Gros lots mensuels",
  ml_monthly_prizes_desc:
    "Profitez des gros lot prêts de Kadow Club en un clic",
  ml_prize_type_subtitle: "Type de gros lots à offrir à vos joueurs",
  modify_avg_basket: "Modifier mon panier moyen ({{avgBasket}})",
  modify_avg_basket_formula_text:
    "Formule de calcul : [nombre de cadeaux remis] x [panier moyen = {{avgBasket}}] x 1,5 (accompagnants) + montant des photos d'addition",
  modify_avg_basket_modal_description:
    "Entrez le montant moyen de votre panier en {{currency}}.",
  modify_avg_basket_modal_helper_text:
    "Cette valeur sera utilisée pour calculer l'apport d'affaires estimé.",
  modify_avg_basket_modal_input_placeholder: "Montant en €",
  modify_avg_basket_modal_title: "Modifier mon panier moyen",
  modify_emoji: "Modifier l'emoji",
  money_sigle: "€",
  monthFromLabel: "Du",
  monthly_ht: "Mensualité HT",
  monthly_lottery: "Gros lots mutualisés",
  monthly_lottery_description:
    "Ces gros lots s’afficheront automatiquement aux côtés de vos cadeaux pour faire rêver vos clients (tirage au sort tous les 1ers du mois)",
  monthly_performance_reports: "Rapports de performance mensuels",
  monthly_statistics: "Rapports mensuels",
  monthly_stats_back_button: "← Retour",
  monthly_stats_birthdays_collected: "dates d'anniversaire collectées",
  monthly_stats_boost_message:
    "En {{monthText}}, Kadow club a boosté votre business à hauteur de {{amount}} 🚀",
  monthly_stats_check_in: "check-ins",
  monthly_stats_emails_collected: "emails récoltés",
  monthly_stats_estimated_value_header: "Valeur estimée ({{currency}})",
  monthly_stats_estimation_method_header: "Méthode d'estimation",
  monthly_stats_facebook_actions: "actions Facebook",
  monthly_stats_gifts_redeemed_plural: "cadeaux récupérés",
  monthly_stats_gifts_redeemed_singular: "cadeau récupéré",
  monthly_stats_google_actions: "actions avis Google",
  monthly_stats_instagram_actions: "actions Instagram",
  monthly_stats_new_sponsored_customers_plural:
    "nouveaux clients issus du parrainage",
  monthly_stats_new_sponsored_customers_singular:
    "nouveau client issu du parrainage",
  monthly_stats_new_visits_calculation:
    "Nouvelles visites x panier moyen ({{avgBasket}}) x {{multiplier}} (pour inclure les accompagnants)",
  monthly_stats_no_communication_materials:
    "Il semble que vos supports de communication n'étaient pas en place sur ce mois",
  monthly_stats_no_players:
    "Vous aurez accès à des rapports à chaque fin de mois dès que votre dispositif sera lancé.",
  monthly_stats_per_action: "{{amount}} / action",
  monthly_stats_per_birthday: "{{amount}} / date d'anniversaire",
  monthly_stats_per_checkin: "{{amount}} / check-in",
  monthly_stats_per_email: "{{amount}} / adresse email",
  monthly_stats_per_number: "{{amount}} / numéro",
  monthly_stats_per_sponsorship: "{{amount}} / parrainage",
  monthly_stats_phones_collected: "numéros de téléphone récoltés",
  monthly_stats_receipts_scanned: "d'additions scannées",
  monthly_stats_receipts_scanned_amounts: "Montants scannés",
  monthly_stats_results_header: "Résultats du mois de {{monthText}}",
  monthly_stats_sponsored_authentications_plural: "parrainages",
  monthly_stats_sponsored_authentications_singular: "parrainage",
  monthly_stats_total: "Total",
  months: "{{duration}} mois",
  must_be_number_for_token: "Le nombre de jetons doit être un nombre entier",
  must_enter_shipping_address:
    "Vous devez indiquer une adresse de livraison pour {{placeName}} avant de valider vos supports de communication.",
  my_account: "Mon compte",
  name: "Nom",
  needs_redesign: "En cours de modification",
  new_venue_add: "Ajouter une licence",
  new_venue_add_1: "Ajouter une",
  new_venue_add_2: "licence",
  new_venue_no_accounts_available: "Aucun compte disponible",
  new_venue_same_legal_entity_no: "Non, c'est une entité juridique différente",
  new_venue_same_legal_entity_yes: "Oui, utiliser la même entité juridique",
  new_venue_select_account: "Sélectionnez un compte",
  new_venue_select_plan: "Sélectionnez un plan d'abonnement",
  new_venue_step1_title:
    "S'agit-il de la même entité juridique qu'une licence existante ?",
  next: "Suivant",
  next_step_button: "Étape suivante",
  no: "Non",
  noActiveSubscriptionsMessage: "Pas d'abonnements.",
  noTokenAlert: "Pas de token",
  no_card_subscription_description:
    "Vous êtes sur le point de vous abonner au plan {{planName}}. Aucune carte de paiement n'est requise pendant le mois gratuit.",
  no_card_subscription_description_2:
    "Si vous décidez de garder le dispositif, vous pourrez insérer votre CB à tout moment durant le test gratuit.",
  no_data: "Pas de données dans cet intervalle de temps.",
  no_invoices: "Aucune facture pour le moment.",
  no_saved_payment_methods: "Aucune carte enregistrée",
  none: "non",
  none_feminine: "Aucune.",
  notFoundMessage:
    "Oups ! La page que vous recherchez n'existe pas ou a été déplacée.",
  notImplementedAlert: "Non implémenté",
  not_applicable: "N/A",
  numberOfTablesLabel: "Nombre de tables",
  numericIdPlaceholder: "Identifiant numérique",
  ocr_legend: "Photo d'addition",
  of: "de",
  ok: "OK",
  okButton: "OK",
  onboarding_choose_ctas_longtitle:
    "Vos appels à l'action correspondent aux actions qui seront demandées aux joueurs avant de jouer.",
  onboarding_choose_ctas_name: "Appels à l'action",
  onboarding_choose_ctas_title: "Choisissez vos appels à l'action",
  onboarding_choose_distribution_name: "Supports de com'",
  onboarding_choose_distribution_title: "Choisissez vos canaux de diffusion",
  onboarding_choose_emails_longtitle:
    "Gardez contact avec vos clients en 100% automatisé et faites-les jouer de chez eux pour qu'ils ne vous oublient jamais.",
  onboarding_choose_emails_name: "Emails automatisés",
  onboarding_choose_emails_title:
    "Choisissez vos séquences d'e-mails automatisées",
  onboarding_choose_gifts_longtitle:
    "Il s'agit des lots que vous allez remettre aux gagnants.",
  onboarding_choose_gifts_name: "Cadeaux",
  onboarding_choose_gifts_title: "Choisissez vos cadeaux",
  onboarding_logo_and_colors_name: "Logo et couleurs",
  onboarding_logo_and_colors_title: "Logo et couleurs",
  onboarding_select_games_longtitle:
    "Nous proposons plusieurs types de jeu parmi les plus célèbres.",
  onboarding_select_games_name: "Jeux",
  onboarding_select_games_title: "Sélectionnez vos jeux",
  onboarding_settings: "Réglages",
  onlinePOSAGallery_template_step1: "Personnalisez puis téléchargez un modèle",
  onlinePOSAGallery_template_step2: "Insérez-le sur le réseau de votre choix",
  onlinePOSAGallery_template_step3: "Ajoutez le lien du jeu",
  onlinePOSAGallery_template_step4: "Publiez votre jeu",
  online_posa_copy_link:
    "Copiez le lien pour le partager sur vos réseaux sociaux ou vos campagnes en ligne",
  online_posa_gallery_title:
    "Nos conseils pour promouvoir votre jeu en ligne 🎲",
  online_posa_ig_post: "Post Instagram",
  online_posa_ig_story: "Story Instagram",
  online_posa_templates_heading:
    "Découvrez des templates pour vos Insta stories",
  open_pdf: "Ouvrir le document",
  optins: "Opt-ins",
  order_summary_advanced_email_sequences: "séquences d'email avancées",
  order_summary_all_actions: "toutes les actions",
  order_summary_annual: "Annuel",
  order_summary_calls_to_action: "{{count}} appel(s) à l'action",
  order_summary_custom_communication_materials:
    "supports de communications personnalisés",
  order_summary_custom_logo_and_colors: "logo et couleurs personnalisés",
  order_summary_discount: "Réduction ({{percent}} %)",
  order_summary_free_month: "Essai gratuit (1 mois)",
  order_summary_from: "De ",
  order_summary_games_of_chance: "jeux de hasard",
  order_summary_monthly: "Mensuel",
  order_summary_monthly_jackpots: "gros lots mensuels",
  order_summary_monthly_payment_post_tax: "Mensualité TTC",
  order_summary_monthly_payment_pre_tax: "Mensualité HT",
  order_summary_order: "Commande",
  order_summary_pack_enterprise: "Pack entreprise",
  order_summary_pack_premium: "Pack Premium",
  order_summary_performance_games: "jeux de performance",
  order_summary_starting_next_month: "A partir du mois prochain : ",
  order_summary_themed_skins: "habillages thématiques",
  order_summary_this_month: "Ce mois-ci : ",
  order_summary_to: " à ",
  order_summary_total_post_tax: "Total TTC",
  order_summary_total_pre_tax: "Total HT",
  order_summary_vat: "TVA ({{percent}})",
  ordinal_suffix_eme: "ème",
  ordinal_suffix_ere: "ère",
  ordinal_suffix_nd: "nd",
  ordinal_suffix_rd: "rd",
  ordinal_suffix_st: "st",
  ordinal_suffix_th: "th",
  other: "Autre",
  other_supports: "Autres supports",
  pack_label: "Pack",
  page: "Page",
  paid: "Payé",
  participation: "action",
  participation_distribution: "Joueurs uniques par nombre de participations",
  password: "Mot de passe",
  pay: "Payer",
  pay_amount: "Payer {{amount}}",
  pay_amount_subscription: "S'abonner",
  pay_bill_button: "Payer {{amount}}",
  pay_bill_modal_title: "Payer la facture",
  pay_bill_posa_success_message:
    "Votre facture a été payée avec succès, et la commande a bien été envoyée à l'impression !",
  pay_bill_success_message: "Votre facture a été payée avec succès !",
  pay_bill_success_title: "Paiement réussi",
  payable_from_date: "Après votre mois d'essai gratuit et sans engagement",
  paymentServerError: "Erreur du serveur de paiement",
  payment_done_modal_button_text: "OK",
  payment_done_modal_text: "Votre commande a été envoyée à l'impression",
  payment_done_modal_title: "Paiement effectué\u00A0!",
  payment_error_generic:
    "Nous n'avons pas pu traiter votre paiement pour le moment. Veuillez contacter notre service d'assistance.",
  payment_error_title: "Paiement non effectué",
  payment_in_progress: "Prélèvement en cours",
  payment_transaction_ongoing: "Transaction en cours",
  pdf_mobile_explanation:
    "Cliquez sur le bouton en bas de l'écran pour voir le document PDF.",
  percentage_validation:
    "Le pourcentage minimum doit être compris entre 0 et 100",
  period: "Période",
  period_shortcut_1_day: "1 jour",
  period_shortcut_1_month: "1 mois",
  period_shortcut_2_weeks: "2 semaines",
  period_shortcut_3_months: "3 mois",
  period_shortcut_6_months: "6 mois",
  personalize: "Personnaliser",
  phone_invalid_format: "Format de téléphone invalide",
  phone_label: "Téléphone *",
  phone_number: "Numéro de téléphone",
  phone_placeholder_french: "06xxxxxxxx ou 07xxxxxxxx",
  phone_required: "Le téléphone est requis",
  place: "Etablissement",
  placeholder_shipping_address: "Indiquez une adresse",
  plan_discount_saved: "{{percentage}}% économisés\u00A0!",
  plan_discount_yearly_save:
    "Économisez {{percentage}}% en choisissant l'abonnement annuel",
  plan_option_current_plan: "Plan actuel ✅",
  plan_option_monthly_ht: "/ mois (HT)",
  plan_option_quote: "Sur devis",
  plan_option_request_quote: "Demander un devis",
  player_activity: "Activité des joueurs",
  posa_artwork_issue: "Problème avec le BàT",
  posa_canceled: "Annulée",
  posa_carrier_update: "Mise à jour du transporteur",
  posa_category_at_counter: "At the counter",
  posa_category_at_counter_display: "Au comptoir",
  posa_category_at_table: "A table",
  posa_category_at_table_display: "À table",
  posa_category_delivery_bags: "With delivery bags",
  posa_category_delivery_bags_display: "Avec les sacs de livraison",
  posa_category_establishment: "Dans l'établissement",
  posa_category_establishment_display: "Dans l'établissement",
  posa_category_hand_to_hand: "Hand to hand",
  posa_category_hand_to_hand_display: "De main à la main",
  posa_category_point_of_sale: "Dans le point de vente",
  posa_category_point_of_sale_display: "Dans le point de vente",
  posa_category_reception_common: "À l'accueil et espaces communs",
  posa_category_reception_common_display: "À l'accueil et espaces communs",
  posa_category_reprint_existing: "By reprinting existing materials",
  posa_category_reprint_existing_display:
    "En réimprimant des supports en place",
  posa_category_rooms: "Dans les chambres",
  posa_category_rooms_display: "Dans les chambres",
  posa_category_social_media: "Via social media",
  posa_category_social_media_display: "Via mes réseaux sociaux",
  posa_category_table: "À table",
  posa_category_table_display: "À table",
  posa_delivered: "Livrée",
  posa_delivered_at_neighbours: "Livrée chez des voisins",
  posa_delivered_at_pickup_point: "Livrée en point relais",
  posa_delivery_failed: "Livraison échouée",
  posa_download_qr_code: "Télécharger le QR code",
  posa_flyer_a5: "Flyer A5 (14,8x21 cm)",
  posa_flyer_a6: "Flyer A6 (10,5x14,8 cm)",
  posa_form_activity_question: "Quelle est votre activité ?",
  posa_form_delivery_bag_supports_question:
    "Pour communiquer via vos sacs de livraison, vous préférez :",
  posa_form_delivery_clients_per_day:
    "Combien de clients livraison / take away avez-vous par jour ?",
  posa_form_delivery_no_game:
    "Je ne souhaite pas faire jouer mes clients livraison",
  posa_form_delivery_print_on_bag: "Sacs de livraison",
  posa_form_delivery_service_question: "Livraison / à emporter",
  posa_form_delivery_staple_business_card: "Agrapher une carte cadeau",
  posa_form_delivery_staple_flyer: "Agrafer un flyer A6",
  posa_form_delivery_stick_sticker: "Coller un sticker sur chaque sac",
  posa_form_dine_in_service_question: "Restauration sur place",
  posa_form_establishment_none:
    "Je ne souhaite aucune de ces options dans mon établissement",
  posa_form_establishment_poster_a2: "Affiche A2",
  posa_form_establishment_sticker_dome: "Sticker dome 7,5 x 7,5 (recommandé)",
  posa_form_establishment_sticker_rond: "Sticker rond normal 10 x 10",
  posa_form_establishment_support_question:
    "Au sein de votre établissement, quel support de communication préférez-vous installer ?",
  posa_form_items_selected: "{{count}} item sélectionné",
  posa_form_items_selected_plural: "{{count}} items sélectionnés",
  posa_form_none: "Aucun",
  posa_form_preview_delivery_bag_flyer_a6:
    "Imprimez {{quantity}} flyers A6 (10,5 x 14,8 cm) et agrafez les sur vos sacs de livraison",
  posa_form_preview_delivery_bag_presence:
    "☑️ Assurez-vous que votre jeu soit sur tous vos sacs de livraison",
  posa_form_preview_delivery_bag_stickers10x10:
    "Commandez {{quantity}} stickers (10 x 10 cm) et collez-les sur tous vos sacs de livraison",
  posa_form_preview_establishment: "☑️ Communiquez dans votre établissement",
  posa_form_preview_hand_to_hand: "☑️ Diffusez le jeu de main-à-main",
  posa_form_preview_hand_to_hand_description:
    "Imprimez {{quantity}} cartes cadeaux (format carte de visite) et donnez les à vos clients à leur arrivée ou à leur départ",
  posa_form_preview_reprint_supports:
    "☑️ Réimprimez des supports faisant partie de votre environnement",
  posa_form_preview_reprint_supports_description:
    "Veuillez téléverser les supports sur lesquels vous souhaitez que nous intégrions votre jeu et QR code, dans un format modifiable (ai, .indd, .pdf, canva). Vous recevrez nos propositions visuelles par e-mail dans les prochains jours.",
  posa_form_preview_table_presence:
    "☑️ Assurez vous que votre jeu soit toujours visible sur vos tables",
  posa_form_preview_table_presence_flyer_a5:
    "Imprimez au moins {{quantity}} flyers A5 (14,8 x 21 cm) recto-verso et disposez les dans des chevalets sur toutes vos tables",
  posa_form_preview_table_presence_flyer_a6:
    "Imprimez au moins {{quantity}} flyers A6 (10,5 x 14,8 cm) recto-verso et disposez les dans des chevalets sur toutes vos tables",
  posa_form_preview_table_presence_stickers_dome:
    "Commandez au moins {{quantity}} stickers dome (7,5 x 7,5) et collez les sur toutes vos tables",
  posa_form_preview_title:
    "Nos conseils pour promouvoir votre jeu en point de vente 🏆",
  posa_form_retake: "Reprendre le formulaire",
  posa_form_status_created: "Envoyé à notre designer",
  posa_form_status_done: "Terminé",
  posa_form_status_in_progress: "En cours",
  posa_form_status_pending_am: "En cours",
  posa_form_status_pending_client: "A valider",
  posa_form_status_rejected_by_team: "Rejetée par l'équipe",
  posa_form_status_resent: "En cours",
  posa_form_support_packaging_imprimables: "Packaging imprimables",
  posa_form_support_sac_livraison: "Sac de livraison",
  posa_form_table_how_many: "Combien de tables avez-vous ?",
  posa_form_table_no_game: "Je ne souhaite pas faire jouer mes clients à table",
  posa_form_table_stickers10x10: "Sticker rond normal 10 x 10",
  posa_form_table_stickers_dome: "Sticker dome 7,5 x 7,5 (recommandé)",
  posa_form_table_supports_question:
    "Quel support de communication vous semble le plus adapté à vos tables ?",
  posa_form_title: "Formulaire de recommandations personnalisées ✏️",
  posa_form_upload_support: "Téléverser",
  posa_form_view_result: "Voir le résultat",
  posa_form_which_supports_do_you_use:
    "Parmi ces supports, lesquels utilisez-vous ?",
  posa_format_a_long: "Carte-cadeau (21x7,4 cm)",
  posa_format_a_long_desc:
    "Remise en même temps que l'addition ou la facture, elle crée un effet surprise et prolonge l'expérience client. Un geste simple qui donne envie de tenter sa chance !",
  posa_format_businesscardsstandard_desc: "",
  posa_format_chevalet_a5_desc:
    "Posé sur les tables ou au comptoir, il offre une visibilité optimale du jeu à vos clients. Un format élégant qui attire le regard sans encombrer l'espace !",
  posa_format_chevalet_a6_desc:
    "Compact et discret, il s'intègre parfaitement sur vos tables ou comptoirs pour rappeler le jeu à vos clients en toute simplicité.",
  posa_format_flyer_a5_desc:
    "Agrafé directement à vos sacs, il garantit que chaque client repart avec l'info du jeu sous les yeux. Il peut également être distribué à vos clients ou être utilisé dans une logique d'acquisition. Simple, économique et efficace !",
  posa_format_flyer_a6_desc:
    "Agrafé directement à vos sacs, il garantit que chaque client repart avec l'info du jeu sous les yeux. Il peut également être distribué à vos clients ou être utilisé dans une logique d'acquisition. Simple, économique et efficace !",
  posa_format_stickers10x10_desc:
    "Véritable couteau suisse il s'adapte à tous vos besoins : collé sur un sac, un menu, un colis ou même une vitrine, un support flexible pour promouvoir le jeu partout où vous le souhaitez.",
  posa_format_stickers_dome_desc:
    "Avec son effet bombé et brillant, il attire tous les regards. Résistant dans le temps et élégant, un véritable accroche-jeu !",
  posa_gallery_description:
    "Choose your templates and print materials yourself, or place your order directly via our platform.",
  posa_item_a4_counter_display: "Chevalet de comptoir A4",
  posa_item_a4_counter_display_display: "Chevalet de comptoir A4",
  posa_item_a4_display: "Chevalet A4",
  posa_item_a4_display_display: "Chevalet A4",
  posa_item_a5_display: "Chevalet A5",
  posa_item_a5_table_tent_display: "Chevalet de table A5",
  posa_item_a6_display: "Chevalet A6",
  posa_item_a6_display_display: "Chevalet A6",
  posa_item_a6_flyer: "Flyer A6",
  posa_item_a6_flyer_display: "Flyer A6",
  posa_item_a6_table_tent: "Chevalet de table A6",
  posa_item_a6_table_tent_display: "Chevalet de table A6",
  posa_item_bag_printing: "Impression sur sac",
  posa_item_bag_printing_display: "Impression sur sac",
  posa_item_business_card: "Carte cadeau (format carte de visite)",
  posa_item_business_card_display: "Carte de visite",
  posa_item_coasters: "Sous-bocks",
  posa_item_coasters_display: "Sous-bocks",
  posa_item_dome_sticker: "Sticker dôme (recommandé)",
  posa_item_dome_sticker_display: "Sticker dôme (recommandé)",
  posa_item_gift_card: "Carte cadeau",
  posa_item_gift_card_display: "Carte cadeau",
  posa_item_kakemono: "Kakémono (85 x 200 cm)",
  posa_item_kakemono_display: "Kakémono",
  posa_item_other_printable: "Autre support imprimable",
  posa_item_other_printable_display: "Autre support imprimable",
  posa_item_paper_menu: "Paper menu",
  posa_item_paper_menu_display: "Menu papier",
  posa_item_placemat: "Set de table (recommandé)",
  posa_item_placemat_display: "Set de table (recommandé)",
  posa_item_post_format: "Format post",
  posa_item_post_format_display: "Format post",
  posa_item_poster: "Affiche",
  posa_item_poster_a2: "Affiche A2 (420 x 594 mm)",
  posa_item_poster_a3: "Affiche A3 (297 x 420 mm)",
  posa_item_poster_a4: "Affiche A4 (210 x 297 mm)",
  posa_item_poster_display: "Affiche",
  posa_item_shelf_stopper: "Stop rayon",
  posa_item_shelf_stopper_display: "Stop rayon",
  posa_item_stapled_a6_flyer: "Flyer A6 agrafé",
  posa_item_stapled_a6_flyer_display: "Flyer A6 agrafé",
  posa_item_stapled_flyer: "Flyer agrafé",
  posa_item_stapled_flyer_display: "Flyer agrafé",
  posa_item_sticker: "Sticker",
  posa_item_sticker_display: "Sticker",
  posa_item_story_format: "Format story",
  posa_item_story_format_display: "Format story",
  posa_item_welcome_booklet: "Livret d'accueil",
  posa_item_welcome_booklet_display: "Livret d'accueil",
  posa_item_window_sticker: "Sticker vitrine",
  posa_item_window_sticker_display: "Sticker vitrine",
  posa_list_next: "Découvrir mes supports recommandés",
  posa_list_previous: "Précédent",
  posa_list_quantity: "Quantité",
  posa_list_quantity_required:
    "Vous devez choisir des quantités pour chaque support",
  posa_list_selected_supports: "Supports sélectionnés",
  posa_list_total_ht: "Total HT",
  posa_list_total_ttc: "Total TTC",
  posa_list_total_ttc_label: "Total TTC  ",
  posa_list_type: "Type",
  posa_list_unit_price: "Prix unitaire",
  posa_list_units: "{{qty}} unité{{s}} - {{price}} HT",
  posa_list_unknown: "Inconnu",
  posa_mode_offline: "En physique",
  posa_mode_online: "En ligne",
  posa_model: "Modèle {{templateName}}",
  posa_must_pay_before_validate:
    "Ce support de communication doit être réglée par carte bancaire avant validation. Choisissez une carte bancaire ci-dessous ou ajoutez-en une nouvelle.",
  posa_ongoing_printing: "Commandes en cours",
  posa_onsite: "Sur place",
  posa_order_date: "Date de commande",
  posa_past_artwork: "Commandes passées",
  posa_preparing: "En préparation",
  posa_preview_modal_title: "Proposition de visuel pour validation",
  posa_printing_ongoing: "En cours d'impression",
  posa_quantity_default: "des",
  posa_shipped: "Expédiée",
  posa_short: "Supports",
  posa_sticker: "Sticker standard (10x10 cm)",
  posa_sticker_dome: "Sticker dôme (7,5x7,5 cm)",
  posa_takeaway: "À emporter",
  posa_template: "Modèle {{template}}",
  posa_to_ship: "Prête pour expédition",
  posa_to_validate_explanation_text:
    "Les commandes ci-dessous attendent une validation et un paiement de votre part.",
  posa_validate_artwork_title: "Validation de bon à tirer",
  posa_validate_explanation:
    "Si ce bon à tirer vous convient, cliquez sur le bouton '{{validate_button_text}}'. Le cas échéant, cliquez sur le bouton '{{do_not_validate_button_text}}' puis laissez un commentaire.",
  posa_wording_burger: "Burger",
  posa_wording_cadeau: "Cadeau",
  posa_wording_cocktail: "Cocktail",
  posa_wording_iphone: "iPhone",
  posa_wording_label: "Texte",
  posa_wording_pizza: "Pizza",
  posa_wording_plat: "Plat",
  posa_wording_plats_boissons: "Plats & boissons",
  posa_wording_repas: "Repas",
  posa_wording_sejour: "Séjour offert",
  premium: "Premium",
  premium_plus: "Premium +",
  previous: "Précédent",
  prize: "Cadeau",
  prize_name_max_characters:
    "Le nom du cadeau ne peut pas dépasser {{count}} caractères",
  prizes_configurator_choose_my_prize: "Configurer mon cadeau",
  prizes_configurator_choose_my_prizes: "Configurer mes cadeaux",
  prizes_configurator_max_per_week: ", max {{quantity}}/semaine",
  prizes_configurator_my_prizes: "Cadeaux dans votre jeu",
  prizes_configurator_no_name_gift: "Cadeau sans nom ",
  prizes_configurator_see_video: "Voir la vidéo",
  prizes_configurator_text_about_prizes:
    "Choisissez des cadeaux qui donneront envie à vos clients de jouer, et de revenir chez vous.",
  profile_billing_country: "Pays de facturation",
  profile_company_name: "Nom de l'entreprise",
  profile_timezone: "Fuseau horaire",
  promoCodeAppliedMessage: "Code promo appliqué\u00A0!",
  promoCodePlaceholder: "Entrez votre code promo...",
  public_name: "Nom public",
  public_posa_modal_price: "Prix HT",
  public_posa_modal_quantity: "Quantité",
  public_posa_modal_title_prefix: "Prix pour",
  public_posa_page_heading: "Tarifs publics des supports de communication",
  public_posa_page_subheading:
    "Ces prix sont susceptibles de changer et sont mis à jour toutes les heures.",
  public_posa_table_name: "Nom",
  public_posa_table_photos: "Photos",
  public_posa_table_price: "Prix HT",
  public_posa_table_price_list: "Grille tarifaire",
  public_price_ht: "Prix public HT ",
  public_prices_guarantee_text:
    "* La garantie est applicable sous réserve du respect  de nos préconisations en matière de communication du jeu - c'est à dire, au moins 2 supports fixes (ex: stickers, impression sur sac etc.) et au moins un support remis de main à la main (ex: carte cadeau, flyer etc). Le retour sur investissement est évalué selon une valorisation en € de chaque action générée à travers le jeu (ex 1 avis Google = 1€). Si, malgré le respect de nos préconisations, le montant de l'abonnement n'est pas rentabilisé dans un délai de 3 mois suivant la diffusion du jeu, un remboursement intégral sera effectué sur demande. Attention, le jeu est considéré comme diffusé dès lors que les supports de communication sont en place avec un minimum de 30 joueurs uniques/semaine.",
  public_prices_heading: "Retour sur investissement garanti ou remboursé*",
  qrCodeScanInstruction:
    "Scannez ce QR code avec votre mobile pour tester votre jeu.",
  quantity: "Quantité",
  quantity_per_week_placeholder: "Quantité maximale par semaine",
  redeem_4_digits_explanation:
    "Un membre de votre personnel devra insérer un code à 4 chiffres sur le téléphone du gagnant.",
  redeem_code_4_digits: "Code de validation",
  redeem_code_validation_error: "Le code doit contenir exactement 4 chiffres",
  redeem_qr_code_explanation:
    "Un membre de votre personnel devra utiliser un smartphone pour canner un QR code affiché sur le téléphone du gagnant, puis enregistrer la remise du cadeau en insérant un code à 4 chiffres (ci-dessous).",
  redeem_soft_redeem_explanation:
    "Une fois le coupon révélé, les gagnants ont quelques minutes pour vous le montrer et récupérer leur cadeau, suite à quoi il s’auto-détruira automatiquement.",
  redeem_voucher: "Coupon cadeau déchiré",
  redeemed: "Remis",
  redemption_date: "Date de récupération",
  reference: "Référence",
  referral_plays: "Filleul joue",
  refunded: "Remboursé",
  reminder_12h: "12h",
  reminder_24h: "24h",
  reminder_d_plus_3: "J+3",
  reminder_disabled: "Désactivées",
  reminder_m_plus_1: "M+1",
  reminder_m_plus_12: "M+12",
  reminder_m_plus_2: "M+2",
  reminder_m_plus_3: "M+3",
  reminder_m_plus_4: "M+4",
  reminder_m_plus_5: "M+5",
  reminder_m_plus_6: "M+6",
  reminder_w_plus_1: "S+1",
  reminder_w_plus_2: "S+2",
  reminder_w_plus_3: "S+3",
  renewal_date: "Renouvellement",
  repeat_business: "Repeat business",
  replace_logo: "Remplacer le logo",
  required_field: "Ce champ est requis",
  reset_account: "Reset compte",
  returnToHome: "← Retour à l'accueil",
  rising: "Montant",
  saas_flyers_order_delivery_action_next: "Paiement",
  saas_flyers_order_delivery_action_prev: "Précédent",
  saas_flyers_order_delivery_description:
    "Indiquez l'addresse de livraison à laquelle sera envoyée les supports de communication. Validez le payement pour que la commande soit envoyée à notre prestataire. Vous recevrez les supports sous 7 jours ouvrés.",
  saas_flyers_order_payment_action_prev: "Précédent",
  saas_flyers_order_payment_description:
    "Vous devez saisir les informations d'un moyen de paiement valide. Votre carte bancaire ne sera pas utilisée autrement que pour la commande des supports de communication ici.",
  saas_flyers_order_payment_subheading: "Informations de paiement",
  saas_flyers_order_quantity_action_next: "Informations de livraison",
  saas_flyers_order_quantity_action_prev: "Annuler",
  saas_flyers_order_quantity_description:
    "Nous proposons différents supports de communication adaptés à plusieurs cas (commandes sur place, à emporter, etc)",
  saas_flyers_order_quantity_thead_description: "Description",
  saas_flyers_order_quantity_thead_quantity: "Quantité",
  saas_flyers_order_quantity_thead_total_price_ht: "Total HT",
  saas_flyers_order_quantity_thead_type: "Type",
  saas_flyers_order_quantity_thead_unit_price_ht: "Prix unitaire",
  saas_game_configuration_game_preview_label: "Aperçu de votre jeu",
  saas_game_configuration_logo_and_colors_heading: "Logo et couleurs",
  saas_game_configuration_logo_and_colors_subheading:
    "Personnalisez votre jeu en ajoutant votre logo et vos couleurs.",
  saas_summary_completed_section_action_order_pdf: "Commander",
  save: "Enregistrer",
  saving: "Enregistrement...",
  search: "Recherche",
  searchPlaceholder: "Recherche 🔎",
  select: "Sélectionner",
  selectAtLeastOneOption: "Sélectionner au moins une option",
  selectButton: "Sélectionner",
  select_account: "Sélectionner un établissement",
  select_color: "Choisir cette couleur",
  select_highlight: "Sélectionnez un modèle",
  select_highlight_required_title: "Sélection requise",
  select_highlight_required_message:
    "Veuillez sélectionner un jeu avant de continuer.",
  selectedText: "Sélectionné",
  send: "Envoyer",
  send_comment: "Envoyer le commentaire",
  send_email: "N'hésitez pas à nous envoyer un mail à",
  sending: "Envoi...",
  sent_sponsor_legend: "Parrainages envoyés",
  settings_section_coupons: "Coupons cadeaux",
  settings_section_dates: "Dates du jeu",
  settings_section_display: "Affichage",
  shipping_address_city: "Ville",
  shipping_address_city_placeholder: "Paris",

  shipping_address_country: "Pays",
  shipping_address_country_placeholder: "Sélectionnez un pays",
  shipping_address_postal_code: "Code postal",
  shipping_address_postal_code_placeholder: "75001",
  shipping_address_required:
    "Veuillez compléter tous les champs d'adresse de livraison requis avant de continuer.",

  shipping_address_street: "Numéro et voie",
  shipping_address_street_placeholder: "11 rue de la Paix",
  shipping_name: "Contact pour la livraison",
  shipping_phone_number: "Numéro de téléphone à contacter",
  show_all_emojis: "Afficher tous les Emojis",
  showing: "Affichage",
  signup_access_account: "Accédez à votre compte",
  signup_already_have_account: "J'ai déjà un compte",
  signup_background_image_alt: "Image de fond",
  signup_create_account: "C'est parti\u00A0!",
  signup_create_account_link: "Créer un compte",
  signup_create_free_account: "C'est parti\u00A0!",
  signup_email_placeholder: "Saisir votre adresse e-mail",
  signup_email_required: "L'adresse e-mail est obligatoire",
  signup_generic_error:
    "Une erreur s'est produite lors de votre enregistrement. Veuillez réessayer.",
  signup_heading:
    "Créez votre compte en 2 minutes et générez des centaines d’avis Google\u00A0!",
  signup_heading_email:
    "Insérez votre email pour recevoir un code d’authentification et lancer votre jeu gratuit",
  signup_heading_promocode: "Lancez votre jeu en 2 min chrono !",
  signup_invalid_email: "Adresse e-mail invalide",
  signup_login_button: "Se connecter",
  signup_logo_alt: "Logo Kadow",
  signup_wording_ambassador_light:
    "Créez votre compte gratuit et commencez à obtenir plus d'avis Google !",
  signup_wording_ambassador_premium:
    "Créez votre compte pour lancer votre programme Ambassadeur !",
  signup_wording_loyalty_light:
    "Créez votre compte gratuit pour lancer votre jeu de fidélité !",
  signup_wording_loyalty_premium:
    "Créez votre compte pour lancer votre jeu de fidélité !",
  signup_wording_super_premium:
    "Créez votre compte et lancez votre premier jeu !",
  snapchatLinkPlaceholder: "Lien de votre page Snapchat",
  snapchatProfileStatus: "Profil Snapchat",
  soft_redeem_delay: "Délai d'auto-destruction",
  somethingWentWrong: "Quelque chose s'est mal passé.",
  source: "Source",
  sponsoree_authenticated_legend: "Filleuls authentifiés",
  srdelay_10_minutes: "10 minutes",
  srdelay_1_hour: "1 heure",
  srdelay_20_minutes: "20 minutes",
  srdelay_2_hours: "2 heures",
  srdelay_30_minutes: "30 minutes",
  srdelay_45_minutes: "45 minutes",
  srdelay_5_minutes: "5 minutes",
  standard_skin: "Standard",
  start: "Démarrer",
  start_date: "Début",
  start_immediately: "Démarrage immédiat",
  status: "Statut",
  step_email_collect: "Laisser son adresse email",
  step_facebook_like: "Liker la page Facebook",
  step_google_reviews: "Laisser un avis Google",
  step_ig_story: "Faire une story Instagram",
  step_instagram_follow: "S'abonner à votre Instagram",
  step_phone_collect: "Laisser son numéro de téléphone",
  step_snapchat_follow: "S'abonner à votre Snapchat",
  step_social_photo_action: "Prendre une photo sympa",
  step_sponsorship_action: "Parrainer un ami",
  step_tripadvisor_review: "Laisser un avis TripAdvisor",
  sub_duration_monthly: "mensuel",
  sub_duration_yearly: "annuel",
  subscribe_and_pay_on_date:
    "Obtenir mon mois d'essai gratuit et sans engagement",
  subscribe_button: "S'abonner",
  subscription: "Abonnement",
  subscription_start_date_label: "Date de démarrage de l'abonnement",
  subscription_start_label: "Début de l'abonnement",
  support_email: "clients@kadow.club",
  support_request_description:
    "Vous ne retrouvez pas un support en particulier ? Indiquez nous en quelques mots ce que vous avez en tête et nous reviendrons rapidement vers vous",
  surprise_gift: "1 cadeau surprise",
  synthesis: "Synthèse",
  technical_error: "Erreur technique",
  terms_link:
    "https://s3.eu-west-3.amazonaws.com/cadeaudelamaison.com/kadow/pdf/kadow_club_conditions_generales_de_vente_fr.pdf",
  terms_of_sale: "Conditions générales de vente",
  testMyGameButton: "Tester mon jeu",
  time_zone: "Fuseau horaire",
  timezone: "Fuseau horaire",
  to: "au",
  to_pay: "À payer",
  tokens: "Jetons",
  total: "Total : ",
  trigger: "Déclencheur",
  tripAdvisorPageStatus: "Page de notation Trip Advisor",
  turn_your_tablet: "Veuillez tourner votre tablette.",
  type: "Type",
  typeTableHeader: "Type",
  uncategorized: "Accès direct",
  unknown: "Inconnu",
  unknown_game_error: "Jeu inconnu : {{game}}",
  unsubscribe_back_home: "Retour à l'accueil",
  unsubscribe_confirm_button: "Confirmer le désabonnement",
  unsubscribe_confirm_message: "Êtes-vous sûr de vouloir nous quitter ?",
  unsubscribe_confirm_title: "Confirmer le désabonnement",
  unsubscribe_immediately_success_message:
    "Votre désabonnement est effectif immédiatement.",
  unsubscribe_reason_avoid_renewal:
    "Je veux éviter le renouvellement automatique",
  unsubscribe_reason_closing_business: "Je ferme ou je vends mon commerce",
  unsubscribe_reason_competitor: "Je pars chez un concurrent",
  unsubscribe_reason_customers_bored:
    "Mes clients se lassent du jeu/ne jouent plus",
  unsubscribe_reason_error: "Veuillez sélectionner au moins une raison",
  unsubscribe_reason_no_budget: "Je n'ai plus le budget",
  unsubscribe_reason_no_prizes:
    "Je ne souhaite plus faire gagner des prix à mes clients",
  unsubscribe_reason_no_roi: "Je ne vois pas de retour sur investissement",
  unsubscribe_reason_not_adapted: "Ce produit n'est pas adapté à mon activité",
  unsubscribe_reason_objectives_reached: "J'ai déjà atteint mes objectifs",
  unsubscribe_reason_temporary: "C'est temporaire, je reviendrai bientôt",
  unsubscribe_reasons_message:
    "Veuillez indiquer la raison de la fin de votre abonnement : ",
  unsubscribe_reasons_title: "Raison du désabonnement",
  unsubscribe_success_message: "Votre abonnement prendra fin le {{endDate}}",
  unsubscribe_success_title: "Votre désabonnement a été enregistré",
  unsupportedPaymentError: "Cas de paiement non pris en charge",
  until_tomorrow: "Jusqu'au lendemain",
  upgrade_plan: "Améliorez votre plan",
  upsell_banner_free_benefit_1:
    "- Personnalisez votre jeu avec votre logo et vos couleurs",
  upsell_banner_free_benefit_2:
    "- Fidélisez vos clients avec des coupons cadeau conçus pour les faire revenir rapidement",

  upsell_banner_free_benefit_3:
    "- Demandez à vos clients de s'abonner à vos réseaux sociaux",
  upsell_banner_free_benefit_4:
    "- Accédez à notre catalogue de jeux, d'appels à l'action et de gros lots",
  upsell_banner_free_benefit_5:
    "- Faites appel à nos experts pour vous conseiller",
  upsell_banner_free_title: "Ce que vous obtiendrez en passant Premium + 🏆",
  upsell_banner_free_trial_button: "Demander un test gratuit",
  upsell_banner_paid_tip_1:
    "- Mettez en place 2 supports de communication minimum",
  upsell_banner_paid_tip_2:
    "- Optez pour la carte cadeau remise de main à la main à vos clients (c'est le support le plus performant 🥇)",
  upsell_banner_paid_tip_3:
    "- Combinez cadeaux à forte valeur en petites quantités et cadeaux de faible valeur en grande quantité",
  upsell_banner_paid_tip_4:
    "- Même vos cadeaux de faible valeur doivent rester attractifs si vous souhaitez faire revenir vos clients",
  upsell_banner_paid_tip_5:
    "- Sécurisez vos revenus issus des cadeaux récupérés avec des conditions de récupération cohérentes (minimum d'achat etc.)",
  upsell_banner_paid_title: "💡 Nos conseils pour maximiser vos résultats",
  upsell_ctas: "Actions Premium +",
  upsell_game_title: "Jeux Premium +",
  upsell_premium_button: "Passer Premium +",
  utm_source_4_digit_code_email: "Email de code à 4 chiffres",
  utm_source_a3_poster: "Affiche A3",
  utm_source_a4_poster: "Affiche A4",
  utm_source_a6_flyer: "Flyer A6",
  utm_source_balloon_pop_event: "Temps fort - éclate-ballons",
  utm_source_banner: "Bâche",
  utm_source_banner_stand: "Kakémono",
  utm_source_big_prize_defeat: "Défaite gros lot",
  utm_source_big_prize_reminder: "Email de relance pour le gros lot",
  utm_source_business_card: "Carte de visite",
  utm_source_classic_stickers: "Stickers classiques",
  utm_source_coaster: "Sous-verre",
  utm_source_dome_stickers: "Stickers dôme",
  utm_source_easel: "Chevalet",
  utm_source_email: "Email",
  utm_source_expired_coupon: "Coupon expiré",
  utm_source_facebook: "Facebook",
  utm_source_flyer: "Flyer",
  utm_source_forecast_cancellation: "Annulation de pronostic",
  utm_source_forecast_confirmation: "Confirmation de pronostic",
  utm_source_forecast_result: "Résultat de pronostic",
  utm_source_game: "Jeu",
  utm_source_gift_retrieved: 'Email "cadeau récupéré"',
  utm_source_gift_won: 'Email "cadeau gagné"',
  utm_source_halloween_event: "Temps fort - Halloween",
  utm_source_insert: "Encart",
  utm_source_instagram: "Instagram",
  utm_source_instagram_story: "Story Instagram",
  utm_source_laminated_stickers: "Stickers pelliculés",
  utm_source_lottery_ticket_won_email: "Email 'ticket de tombola gagné'",
  utm_source_manual_photo_validation: "Validation manuelle de photo d'addition",
  utm_source_newsletter: "Newsletter",
  utm_source_pizza_box: "Boite à pizza",
  utm_source_placemat: "Set de table",
  utm_source_poster: "Affiche",
  utm_source_qr_code: "QR code",
  utm_source_screen: "Ecran",
  utm_source_sea: "SEA",
  utm_source_share: "Partage",
  utm_source_sms: "SMS",
  utm_source_social_media: "Réseaux sociaux",
  utm_source_takeaway: "A emporter",
  utm_source_terminal: "Borne",
  utm_source_test: "Test",
  utm_source_tokens_offered_15th: "Jetons offerts (15 du mois)",
  utm_source_website: "Site web",
  utm_source_welcome_email_day_3: "Email de bienvenue (J+3)",
  utm_source_whatsapp: "Whatsapp",
  utm_source_window_decal: "Vitrophanie",
  utm_source_wom_referral_plays: "Bouche à oreilles - filleu joue",
  utm_source_wom_referral_retrieves: "Bouche à oreilles - filleul récupère",
  utm_source_wordle_event: "Temps fort - wordle",
  utm_stickers: "Stickers",
  validPhoneNumberMessage: "Veuillez saisir un numéro de téléphone valide",
  validate: "Valider",
  validate_button: "Valider",
  view: "Voir",
  virality_actions_label: "Actions réalisées",
  virality_desktop_warning: "Sur desktop, espace trop grand pour ce graphe.",
  virality_drive_to_store_label: "Drive-to-store",
  virality_sponsorees_label: "Filleuls",
  visit: "Visite",
  vouchers: "Codes promo (jeu classique)",
  wellness: "Beauté et bien-être",
  what_support_looking_for: "Quel type de support cherchez-vous ? *",
  winners: "Gagnants",
  won: "Gagnés",
  yes: "Oui",
  yourAnimationsHeading: "Dashboard",
  yourGameHeading: "Votre jeu",
  your_animation: "Jeux",
  youtube_video_player: "Lecteur vidéo YouTube"
};

export default fr;
